import { all } from "redux-saga/effects";
import { combinedSagas as authSagas } from "./auth";
import { combinedSagas as scheduleSagas } from "./schedule/sagas";
import { combinedSagas as logSagas } from "./log/sagas";
import { combinedSagas as zoneSagas } from "./zone/sagas";
import { combinedSagas as adminSagas } from "./admin/sagas";

export default function* root() {
  yield all([
    authSagas(),
    logSagas(),
    zoneSagas(),
    scheduleSagas(),
    adminSagas(),
  ]);
}
